import React, { useState } from "react";
import { BsFillPatchCheckFill } from "react-icons/bs";
import ScrollTrigger from "react-scroll-trigger";

const Skills = () => {
  const [animationOn, setAnimationOn] = useState(false);

  return (
    <>
      <div className="skills" id="skills">
        <h1 className="mainHeading">Skills</h1>
        <p className="mainPara">My Technical Skills</p>
        <div className="skillsContent">
          <div className="skill animate__animated animate__fadeInLeft">
            <h3>Business & Product Management skills:</h3>
            <div className="skillCon">
              {[
                "Product Management",
                "Cross-Functional Collaboration",
                "User Research & Customer Interviews",
                "Market Analysis & Strategy",
                "Roadmap Development",
                "Stakeholder Management",
                "Agile Methodologies",
                "Communication & Presentation",
              ].map((skill, index) => (
                <div className="skillLang" key={index}>
                  <p className="lang">
                    <BsFillPatchCheckFill className="langIcon" /> {skill}
                  </p>
                  <p className="qual">Experienced</p>
                </div>
              ))}
            </div>
          </div>

          <div className="skill animate__animated animate__fadeInRight">
            <h3>Technical Skills:</h3>
            <div className="skillCon">
              {[
                "Academic Support Services",
                "SQL",
                "Python",
                "Machine Learning & AI",
                "JavaScript (React, Node.js)",
                "A/B Testing & Experimentation",
                "Unity & Game Development",
                "Swift & SwiftUI",
                "C++",
                "HTML & CSS",
                "Mobile App Development",
              ].map((skill, index) => (
                <div className="skillLang" key={index}>
                  <p className="lang">
                    <BsFillPatchCheckFill className="langIcon" /> {skill}
                  </p>
                  <p className="qual">Proficient</p>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default Skills;
